import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $insertNodes,
  $isRootOrShadowRoot,
  $createParagraphNode,
  COMMAND_PRIORITY_EDITOR,
  createCommand,
  LexicalCommand,
} from 'lexical';
import { $wrapNodeInElement } from '@lexical/utils';
import { $createImageNode, ImageNode } from '../nodes';

export type InsertImagePayload = { src: string; alt?: string };

export const INSERT_IMAGE_COMMAND: LexicalCommand<InsertImagePayload> = createCommand('INSERT_IMAGE_COMMAND');

export function ImagePlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([ImageNode])) {
      throw new Error('ImagePlugin: ImageNode not registered in editor initialConfig');
    }

    return editor.registerCommand(
      INSERT_IMAGE_COMMAND,
      ({ src, alt = '' }) => {
        const imageNode = $createImageNode(src, alt);
        $insertNodes([imageNode]);

        // $insertNodes places block nodes as siblings of the current block.
        // If the cursor was at root level (e.g. empty editor), the image
        // ends up as a direct child of root which is invalid — wrap it.
        if ($isRootOrShadowRoot(imageNode.getParentOrThrow())) {
          $wrapNodeInElement(imageNode, $createParagraphNode).selectEnd();
        }

        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);

  return null;
}
